import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FlagIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 14.4C4 14.4 5 13.6 8 13.6C11 13.6 13 15.2 16 15.2C19 15.2 20 14.4 20 14.4V4.8C20 4.8 19 5.6 16 5.6C13 5.6 11 4 8 4C5 4 4 4.8 4 4.8L4 20"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

FlagIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FlagIcon);
